/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "RepeatIcon",
    menu: "Token",
    url: "GetToken",
  },
  {
    icon: "UsersIcon",
    menu: "Mahasiswa",
    url: "GetBiodataMahasiswa",
  },
  {
    icon: "UsersIcon",
    menu: "Aktivitas  TA",
    url: "aktivitasMahasiswaTA",
  },
  {
    icon: "UsersIcon",
    menu: "Nilai Mahasiswa",
    url: "nilaiMahasiswa",
  },
  {
    icon: "UsersIcon",
    menu: "Kerja Praktik Mahasiswa",
    url: "feeder-kerja-praktik-mahasiswa",
  },
  {
    icon: "ListIcon",
    menu: "Matakuliah Kurikulum",
    url: "feeder-matakuliah-kurikulum",
  },
];
